import { render, staticRenderFns } from "./teamPerformance.vue?vue&type=template&id=61f6e618&scoped=true&"
import script from "./teamPerformance.vue?vue&type=script&lang=js&"
export * from "./teamPerformance.vue?vue&type=script&lang=js&"
import style0 from "./teamPerformance.vue?vue&type=style&index=0&id=61f6e618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6e618",
  null
  
)

export default component.exports